<template>
  <div class="div-top">
    <v-card-text v-if="showMessage">
      <div
        v-for="(item, index) in this.detail"
        :key="index"
      >
        {{ item.detailTitle }}<br>
        <v-chip
          small
          class="mr-1 mb-1"
        >
          {{ item.detailMessage }}
        </v-chip>
      </div>
    </v-card-text>
    <v-card-text
      v-if="showMutiChip"
      class="div-top"
    >
      <div
        v-for="(item, index) in this.mutiDetail"
        :key="index"
      >
        {{ item.detailTitle }}
        <br>
        <v-chip
          v-for="item in item.detailMessage"
          :key="item"
          small
          class="mr-1 mt-1 mb-1"
        >
          {{ item }}
        </v-chip>
      </div>
    </v-card-text>
  </div>
</template>

<script>
export default {
  props: {
    detailDataArray: Object,
  },
  data: () => ({
    detail: [],
    mutiDetail: [],
  }),
  mounted() {
    this.getData();
  },
  watch: {
    detailDataArray: {
      immediate: true,
      deep: true,
      handler() {
        this.getData();
      },
    },
  },
  methods: {
    getData() {
      this.showMessage = this.detailDataArray.showMessage;
      this.detail = this.detailDataArray.detail;
      this.showMutiChip = this.detailDataArray.showMutiChip;
      this.mutiDetail = this.detailDataArray.mutiDetail;
    },
  },
  computed: {
    showMessage: {
      get() {
        return this.detailDataArray.showMessage;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    showMutiChip: {
      get() {
        return this.detailDataArray.showMutiChip;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .div-top {
    margin-top: -20px;
  }
</style>
